import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {ReferralAgreement} from "../../entities/Agency.ts";

export class GetAgencyReferralAgreementUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {}

    execute(agencyId: string): Promise<ReferralAgreement | undefined> {
        return this.agencyRepository.getReferralAgreement(agencyId)
    }
}
